import script from "./navigationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationBar.vue?vue&type=script&setup=true&lang=js"

import "./navigationBar.vue?vue&type=style&index=0&id=57bc0f31&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57bc0f31"]])

export default __exports__